// src/game-system/core/attributes.js

/**
 * @typedef {Object} AttributeDefinition
 * @property {string} name - Full name of the attribute
 * @property {string} abbreviation - Short form (e.g., 'STR')
 * @property {string} description - Description of the attribute
 * @property {string[]} affects - List of game elements this affects
 * @property {Object} [combat] - Combat-related effects
 * @property {Object} [magic] - Magic-related effects
 * @property {Object} [social] - Social interaction effects
 * @property {string[]} skills - Skills affected by this attribute
 */

/**
 * Core attribute definitions for the game system
 * @type {Object.<string, AttributeDefinition>}
 */
export const ATTRIBUTES = {
    strength: {
      name: "Strength",
      abbreviation: "STR",
      description: "Physical power and carrying capacity",
      affects: ["Melee damage", "Carrying capacity", "Athletic ability"],
      combat: {
        meleeDamage: true,
        carryingCapacity: true
      },
      skills: ["Athletics", "Intimidation"]
    },
    dexterity: {
      name: "Dexterity",
      abbreviation: "DEX",
      description: "Agility, reflexes, and balance",
      affects: ["Armor Class", "Initiative", "Ranged attacks"],
      combat: {
        rangedDamage: true,
        initiative: true,
        armorClass: true
      },
      skills: ["Acrobatics", "Stealth", "Sleight of Hand"]
    },
    // ... other attributes
  };
  
  /**
   * Calculate modifier for an ability score
   * @param {number} score - The ability score value
   * @returns {number} The calculated modifier
   */
  export function calculateAttributeModifier(score) {
    return Math.floor((score - 10) / 2);
  }